<template>
  <v-container fluid scroll-region transition="scroll-x-transition">
    <v-row align="center">
      <v-col v-if="success" cols="6" justify-center>
        Ihr Fragebogen wurde erfolgreich gespeichert. Sie können den Browser nun schließen.
      </v-col>
      <v-col v-else cols="6" justify-center>
        Dieser Fragebogen ist bereits abgeschlossen. Für Änderungen wenden Sie sich bitte an die NetWork Team GmbH.
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QuestionnaireLayout from '@/Layouts/Questionnaire'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Fragebogen',
      }
   },
   layout: (h, page) => h(QuestionnaireLayout, [page]),
   props: {
      success: {
         type: Boolean,
         default: false
      },
      title: {
         type: String,
         default: 'Fragebogen',
      }
   }
}
</script>

<style scoped>
</style>
